import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const ACTION_LABELS = {
  login: "Signed in",
  logout: "Signed out",
  import_committed: "Imported a file",
  import_rolled_back: "Undid an import",
  export: "Exported data",
  customers_merged: "Merged customers",
  duplicate_dismissed: "Dismissed a duplicate",
  customer_deleted: "Deleted a customer",
  order_added: "Added an order",
  user_created: "Added a team member",
  user_deleted: "Removed a team member",
  user_password_reset: "Reset a password",
  categories_updated: "Updated categories",
};

export default function AuditPage() {
  const [entries, setEntries] = useState(null);

  useEffect(() => {
    api.get("/audit", { params: { limit: 200 } }).then((r) => setEntries(r.data)).catch((e) => toast.error(apiError(e)));
  }, []);

  return (
    <div className="space-y-8" data-testid="audit-page">
      <div>
        <h1 className="text-4xl sm:text-5xl font-serif font-semibold">Audit Log</h1>
        <p className="text-muted-foreground mt-2">A record of who did what, and when.</p>
      </div>

      <Card className="shadow-sm">
        <CardContent className="p-0">
          <Table data-testid="audit-table">
            <TableHeader>
              <TableRow>
                <TableHead>When</TableHead>
                <TableHead>Who</TableHead>
                <TableHead>What</TableHead>
                <TableHead className="hidden md:table-cell">Details</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {entries === null ? (
                <TableRow><TableCell colSpan={4} className="text-center py-8 text-muted-foreground">Loading…</TableCell></TableRow>
              ) : entries.length === 0 ? (
                <TableRow><TableCell colSpan={4} className="text-center py-8 text-muted-foreground">Nothing recorded yet.</TableCell></TableRow>
              ) : (
                entries.map((e) => (
                  <TableRow key={e.id}>
                    <TableCell className="py-3 text-muted-foreground whitespace-nowrap">
                      {new Date(e.at).toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" })}
                    </TableCell>
                    <TableCell>{e.user_email || "—"}</TableCell>
                    <TableCell className="font-medium">{ACTION_LABELS[e.action] || e.action}</TableCell>
                    <TableCell className="hidden md:table-cell text-muted-foreground text-sm">{e.details}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
